import * as XLSX from 'xlsx';
import { supabase } from './supabaseClient';

export const processFile = async (file) => {
  try {
    const text = await file.text();
    const lines = text.split('\n').filter(line => line.trim() !== '');
    
    // Trouver toutes les colonnes possibles
    const allColumns = new Set();
    lines.forEach(line => {
      const columns = line.split(';');
      columns.forEach((_, index) => {
        allColumns.add(index);
      });
    });

    // Traitement des données
    const data = lines.map(line => {
      const values = line.split(';').map(item => item.trim());
      const row = {};
      
      // Remplir toutes les colonnes, même vides
      Array.from(allColumns).forEach((colIndex) => {
        const columnName = `Colonne ${colIndex + 1}`;
        row[columnName] = values[colIndex] || ''; // Utilise une chaîne vide si la valeur n'existe pas
      });
      
      return row;
    });

    // Création du workbook Excel
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: Array.from(allColumns).map(i => `Colonne ${i + 1}`),
    });

    // Ajuster la largeur des colonnes
    const columnWidths = {};
    data.forEach(row => {
      Object.entries(row).forEach(([key, value]) => {
        const width = Math.max(
          (columnWidths[key] || 0),
          key.length,
          ((value || '').toString().length)
        );
        columnWidths[key] = width;
      });
    });

    worksheet['!cols'] = Object.values(columnWidths).map(width => ({
      wch: width + 2 // +2 pour un peu de marge
    }));

    XLSX.utils.book_append_sheet(workbook, worksheet, "Données");

    // Création du buffer
    const buffer = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });

    return { data, workbook, worksheet, buffer };
  } catch (error) {
    console.error('Erreur lors du traitement du fichier:', error);
    throw new Error('Erreur lors du traitement du fichier');
  }
};

export const downloadExcel = async (workbook, worksheet, fileName, buffer) => {
  try {
    // Upload vers Supabase Storage
    const { data, error: uploadError } = await supabase
      .storage
      .from('excel-files')
      .upload(fileName, buffer, {
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        cacheControl: '3600',
        upsert: true
      });

    if (uploadError) {
      console.error('Erreur détaillée lors de l\'upload:', uploadError);
      throw new Error(`Erreur lors de l'upload: ${uploadError.message}`);
    }

    // Obtenir l'URL publique
    const { data: urlData, error: urlError } = await supabase
      .storage
      .from('excel-files')
      .getPublicUrl(fileName);

    if (urlError) {
      console.error('Erreur lors de la récupération de l\'URL:', urlError);
      throw new Error(`Erreur lors de la récupération de l'URL: ${urlError.message}`);
    }

    if (!urlData || !urlData.publicUrl) {
      throw new Error('URL publique non disponible');
    }

    return {
      path: data.path,
      publicUrl: urlData.publicUrl
    };
  } catch (error) {
    console.error('Erreur complète:', error);
    throw new Error(error.message || 'Erreur lors de la sauvegarde');
  }
};